module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "linking-options.f4ff41d4.svg";